import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';
import { IProductAllocation } from '@/interfaces/product';
import { IBusinessUnit } from '@/interfaces/business-unit';

interface IProps {
  data: IProductAllocation[];
  bus: IBusinessUnit[];
}

const ExcelExport = ({ data, bus }: IProps) => {
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('ProductAllocations');

    // Define header row
    const headers = [
      'ProductCode',
      'ProductName',
      'Status',
      ...(bus?.map(b => {
        return b.name;
      }) || []),
    ];

    worksheet.getColumn('A').width = 20;
    worksheet.getColumn('B').width = 50;
    worksheet.getRow(1).values = headers;
    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'c6251b' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    data.forEach(item => {
      const line = [
        item.ProductCode,
        item.ProductName,
        item.IsActive ? '1' : '0',
      ];
      bus?.map(c => {
        line.push((item[c.name as keyof IProductAllocation] as string) || '0');
      });
      worksheet.addRow(line);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `product-allocations-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
